import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "App-Startup-Comp" }
const _hoisted_2 = {
  "m-tb-0": "",
  "f-w-700": ""
}
const _hoisted_3 = {
  key: 0,
  style: {"display":"inline-block","margin-right":"5px"},
  "mute-primary": "",
  "m-tb-0": "",
  "f-w-600": ""
}
const _hoisted_4 = {
  key: 1,
  "mute-secondary": "",
  style: {"display":"inline-block","margin-right":"5px"},
  "m-tb-0": "",
  "f-w-600": ""
}
const _hoisted_5 = {
  key: 2,
  "mute-secondary": "",
  style: {"display":"inline-block"},
  "m-tb-0": "",
  "f-w-600": ""
}
const _hoisted_6 = { "mute-secondary": "" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { "txt-right": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedComponent && _ctx.clickedComponent(...args))),
      class: "App-Startup-Comp-H"
    }, [
      _createVNode(_component_el_avatar, {
        src: _ctx.business.avatar,
        icon: "el-icon-office-building",
        size: 70
      }, null, 8, ["src"]),
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.business.name), 1),
        _createElementVNode("div", null, [
          (_ctx.business.industry)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.$filters.capitalize(_ctx.business.industry)) + " Industry, ", 1))
            : _createCommentVNode("", true),
          (_ctx.business.stage)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_ctx.$filters.capitalize(_ctx.business.stage)) + " Stage ", 1))
            : _createCommentVNode("", true),
          (_ctx.business.businessModel)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.$filters.capitalize(_ctx.business.businessModel)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.business.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.business.location.description), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "No Location Provided"))
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_divider, { style: {"margin":"10px 0 4px 0px"} }),
      _createVNode(_component_el_row, {
        class: "row-bg",
        justify: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, [
                  (_ctx.isDefault)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        size: "mini",
                        round: ""
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" Current ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isDefault)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "mini",
                      onClick: _ctx.setDefault,
                      type: "primary",
                      round: ""
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode(" Set Default ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}